import { render, staticRenderFns } from "./BrowserStat.vue?vue&type=template&id=52d84e58&"
import script from "./BrowserStat.vue?vue&type=script&lang=js&"
export * from "./BrowserStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports